// extracted by mini-css-extract-plugin
export default {"SlideWapper":"Slider_SlideWapper__GNPSH","slides":"Slider_slides__2AGNV","slide":"Slider_slide__1Nrmi"};